<div
  class="{{
    this.taskSupplierScheduleStore.isDropOff ? 'dropoff' : 'pickup'
  }} w-full h-full flex flex-column"
  *mobxAutorun="{}"
>
  <div class="flex-grow-1">
    <div class="mb-1" style="font-weight: 600">
      <div *ngIf="!this.taskSupplierScheduleStore.isDropOff">Pick-up Date</div>
      <div *ngIf="this.taskSupplierScheduleStore.isDropOff">Drop-off Date</div>
    </div>

    <div class="inputgroup" *ngIf="isMinAndMaxDateSameDay" style="background-color: #f1f1f1">
      <span class="inputgroup-addon"><i class="fa fa-calendar" style="line-height: 1.25"></i></span>
      <div style="padding-left: 35px; padding-top: 5px; cursor: not-allowed">
        {{ this.taskSupplierScheduleStore.scheduledTime | date : 'ccc, MMM d yyyy' }}
      </div>
    </div>

    <div class="inputgroup" *ngIf="!isMinAndMaxDateSameDay">
      <span class="inputgroup-addon"><i class="fa fa-calendar" style="line-height: 1.25"></i></span>
      <p-calendar
        [disabled]="disableDates(this.taskSupplierScheduleStore.task, isDropOff)"
        [ngModel]="taskSupplierScheduleStore.scheduledTime"
        (ngModelChange)="onScheduledDayChange($event)"
        dateFormat="D, d M yy"
        appendTo="body"
        [style]="{
          'background-color': '#fff',
          position: 'absolute',
          'padding-left': '30px',
          width: '100%',
          'border-radius': '3px'
        }"
        [inputStyle]="{
          background: 'none',
          'line-height': '24px',
          'padding-left': '5px',
          'border-radius': '0 3px 3px 0',
          display: 'block',
          width: '100%'
        }"
        [showTime]="false"
        [readonlyInput]="true"
        [minDate]="taskSupplierScheduleStore.minPastDate ?? minDate"
        [maxDate]="taskSupplierScheduleStore.maxPastDate ?? maxDate"
        [touchUI]="false"
        [baseZIndex]="1000000"
      >
      </p-calendar>
    </div>

    <div class="mt-2 mb-1" style="font-weight: 600">
      <div *ngIf="!this.taskSupplierScheduleStore.isDropOff">Pick-up Time Window</div>
      <div *ngIf="this.taskSupplierScheduleStore.isDropOff">Drop-off Time Window</div>
    </div>

    <div class="inputgroup">
      <span class="inputgroup-addon"><i class="fa fa-clock-o" style="line-height: 1.25"></i></span>

      <select
        style="
          border: 0px;
          height: 28px;
          margin-left: 30px;
          width: calc(100% - 30px);
          border-radius: 0 3px 3px 0;
        "
        [ngModel]="taskSupplierScheduleStore.scheduledTimeHour"
        (ngModelChange)="onScheduledHourChange($event)"
      >
        <option
          *ngFor="let option of processedHourBandOptions"
          [value]="option.value"
          [selected]="option.value === taskSupplierScheduleStore.scheduledTimeHour"
        >
          {{ option.label }}
        </option>
      </select>
    </div>

    <div [hidden]="!isDropOff || supplierScheduleStore.isSameDayDelivery">
      <p class="font-bold">Please select reason delivery is on a different day:</p>
      <p-dropdown
        [options]="supplierScheduleStore.noneSameDayDeliveryReasonOptions"
        appendTo="body"
        [ngModel]="supplierScheduleStore.noneSameDayDeliveryReasonId"
        (ngModelChange)="onNoneSameDayDeliveryReasonChange($event)"
        [formControl]="supplierScheduleStore.noneSameDayReasonControl"
        class="mb-2 ng-dirty"
        [style]="{ width: '167px' }"
      >
      </p-dropdown>
    </div>
  </div>
</div>
